
// --- Helper Function (Consider moving to a utils file) ---
/**
 * Formats a JavaScript Date object into 'YYYY-MM-DD' string.
 * @param {Date} dateObject - The Date object to format.
 * @returns {string} The date in 'YYYY-MM-DD' format.
 */
export function formatDateToYYYYMMDD(dateObject) {
    if (!(dateObject instanceof Date) || isNaN(dateObject)) {
      console.error("Invalid date object passed to formatDateToYYYYMMDD:", dateObject);
      const today = new Date();
      return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    }
    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // +1 for month, pad for '05'
    const day = String(dateObject.getDate()).padStart(2, '0'); // pad for '01'
    return `${year}-${month}-${day}`;
  }

/**
 * Removes markdown marks from a text coming from a LLM
 * @param {text} string - the text to remove the markdown marks
 * @returns {string} The text withou the markdown marks
 */
  export function removeMarkdownFences(text) {
    return text.replace(/```markdown/g, '').replace(/```/g, '');
  }


// A universal helper to format any content (string or object) for ReactMarkdown.
export const formatMarkdownContent = (content) => {
    let contentObject = content;

    // --- START OF THE ROBUSTNESS FIX ---
    // If the content is a string, try to parse it as JSON.
    if (typeof content === 'string') {
        try {
            // This handles the case where the DB might send a literal JSON string.
            const parsed = JSON.parse(content);
            // Check if parsing resulted in a non-null object
            if (parsed && typeof parsed === 'object') {
                contentObject = parsed;
            }
        } catch (e) {
            // It's not a JSON string, so just return the original string content.
            return content;
        }
    }
    // --- END OF THE ROBUSTNESS FIX ---

    // If we're here, contentObject is either the original object
    // or the successfully parsed object from a string.
    if (typeof contentObject !== 'object' || contentObject === null) {
        return contentObject || "";
    }

    // This formatting logic now works on a guaranteed object.
    return Object.entries(contentObject).reduce((markdownString, [key, value]) => {
        const heading = key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, ' ');
        markdownString += `### ${heading}\n`;

        if (Array.isArray(value)) {
            value.forEach(item => {
                markdownString += `- ${item}\n`;
            });
        } else {
            markdownString += `${value}\n`;
        }
        markdownString += '\n';
        
        return markdownString;
    }, '').trim();
};